<div class="metadata-editor">
  <label class="metadata-label">Required metadata</label>

  @if (items().length > 0) {
    <ul class="metadata-list">
      @for (key of items(); track key) {
        <li class="metadata-chip">
          <span>{{ key }}</span>
          <button type="button" class="chip-remove" (click)="remove(key)" aria-label="Remove">
            <span class="material-symbols-outlined">close</span>
          </button>
        </li>
      }
    </ul>
  }

  <div class="metadata-add">
    <input
      type="text"
      class="metadata-input"
      placeholder="Add metadata key"
      [ngModel]="draft()"
      (ngModelChange)="draft.set($event)"
      (keyup.enter)="add()"
    />
    <button type="button" class="metadata-add-btn" (click)="add()">Add</button>
  </div>
</div>
